<template>
  <g>
    <circle
      cx="10"
      cy="10"
      r="8.5"
      stroke="currentColor"
      stroke-width="1.5"
      fill="none"
    />
    <path
      d="M10 6V11"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <circle cx="10" cy="13.5" r="1" fill="currentColor" />
  </g>
</template>

<script>
export default {
  name: 'IconWarning',
}
</script>
